import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import * as locationHelper from '../../../utils/location/locationHelper';
import { getStoreCountryName } from '../../../utils/multiTenancyHeaders';

const storeFinderWarnings = window.Jbhifi?.stateStoreFinderWarning;
const { STORE_LOCATIONS } = locationHelper;

const formatAddress = storeAddress => {
  const isNzStoreLocation = window.Jbhifi?.storeLocation === STORE_LOCATIONS.NZ;
  return `${storeAddress.Line1 ? `${storeAddress.Line1}, ` : ''}
    ${storeAddress.Line2 ? `${storeAddress.Line2.replace(/(^\s*,)|(,\s*$)/g, '')}, ` : ''}
    ${storeAddress.Line3 ? `${storeAddress.Line3}, ` : ''}
    ${storeAddress.Suburb ? `${storeAddress.Suburb}, ` : ''}
    ${isNzStoreLocation ? '' : storeAddress.State ? `${storeAddress.State}, ` : ''}
    ${storeAddress.Postcode ? `${storeAddress.Postcode}` : ''}`;
};

const formatLocationList = locations => {
  const formattedLocationList = {};
  if (locations.length > 0) {
    locations.forEach(location => {
      if (window.Jbhifi.storeLocation === STORE_LOCATIONS.AU) {
        formattedLocationList[location.storeAddress.State] = formattedLocationList[location.storeAddress.State] || [];
        formattedLocationList[location.storeAddress.State].push(location);
      } else {
        const storeGroup = locationHelper.getStoreLocationIslandNZ(location.storeAddress.Postcode);
        formattedLocationList[storeGroup] = formattedLocationList[storeGroup] || [];
        formattedLocationList[storeGroup].push(location);
      }
    });
  }
  return formattedLocationList;
};
class storeList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      locations: [],
      formattedLocationList: {},
      postcode: '',
      currentLocation: {},
      scrollToState: '',
    };
    this.browseByState = this.browseByState.bind(this);
    this.storeLocation = window.Jbhifi.storeLocation || STORE_LOCATIONS.AU;
  }

  componentDidUpdate() {
    const parsedSearch = new URLSearchParams(window.location.search);

    const scrollToState = parsedSearch.get('state') ? parsedSearch.get('state').toUpperCase() : null;
    if (scrollToState && !this.state.scrollToState) this.setState({ scrollToState });
    const stateList = document.querySelector(`.${scrollToState}-list`);
    const stateListNode = ReactDOM.findDOMNode(stateList);

    if (stateList && scrollToState && stateListNode) {
      stateListNode.scrollIntoView({
        behaviour: 'smooth',
      });
    }
  }

  static getDerivedStateFromProps(props) {
    return {
      locations: props.locations,
      formattedLocationList: props.postcode ? {} : formatLocationList(props.locations), //*
      currentLocation: props.currentLocation,
      postcode: props.postcode,
    };
  }

  browseByState() {
    this.props.setSearchData('');
    this.props.getLocations('', { hitsPerPage: 1000 });
  }

  render() {
    const { formattedLocationList, locations, postcode, currentLocation, scrollToState } = this.state;

    return (
      <div className="store-list" id="finder-map-results">
        {postcode || Object.keys(currentLocation).length ? (
          <h2>Stores near {postcode ? postcode : 'you'}</h2>
        ) : (
          <h2>Showing stores {getStoreCountryName(this.storeLocation)} wide</h2>
        )}
        {postcode || Object.keys(currentLocation).length ? (
          <div className="finder-map-results-results">
            {locations.length > 0 ? (
              <ul className="store-search-results">
                <li className="key">
                  <span className="name">Store Name</span>
                  <span className="adr">Address</span>
                  <span className="phone">Phone</span>
                  <span className="distance">Distance</span>
                </li>
                {locations.map(location => (
                  <li key={location.objectID}>
                    <a href={`/pages/${location.url}`}>
                      <span className="name">
                        {location.storeName}
                        <br />
                      </span>
                      <span className="adr">
                        {formatAddress(location.storeAddress)}
                        <br />
                      </span>
                      <span className="phone">
                        <span className="phone-hide">Phone: </span>
                        {location.phone}
                      </span>
                      <span className="distance">
                        {locationHelper.getDistance(currentLocation, location._geoloc)}km
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
            ) : (
              <div className="store-list__empty">
                We can't find store information for this postcode, try browsing or check your postcode.
              </div>
            )}
            <button className="store-list__all" onClick={this.browseByState}>
              Browse stores by {this.storeLocation === STORE_LOCATIONS.NZ ? 'region' : 'state'}
            </button>
          </div>
        ) : (
          <div className="finder-map-results-results">
            {formattedLocationList && Object.keys(formattedLocationList).length > 0 ? (
              <Accordion allowZeroExpanded preExpanded={[scrollToState]} className="store-state-results toggle-group">
                {Object.keys(formattedLocationList)
                  .sort()
                  .map(state => {
                    const stateWarning = storeFinderWarnings ? storeFinderWarnings[state.toLowerCase()] : null;
                    const cleanState = state.replace(/\s+/g, '');
                    return (
                      <AccordionItem
                        key={cleanState}
                        uuid={cleanState}
                        className={`${cleanState}-list react-sanfona-item`}
                      >
                        <AccordionItemHeading className="react-sanfona-item-title">
                          <AccordionItemButton>{state}</AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel className="toggle-content">
                          {!!stateWarning && stateWarning.enabled ? (
                            <div className="state-warning-message">
                              <p className="option__availability-msg option__availability-msg--orange">
                                <svg
                                  id="warnIcon"
                                  className="icon--warning"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 18 18"
                                >
                                  {' '}
                                  <use xlinkHref="#iconWarning" />
                                  <title>{stateWarning.heading}</title>
                                </svg>
                                {stateWarning.heading}
                              </p>
                              <p
                                className="option__availability-text"
                                dangerouslySetInnerHTML={{ __html: stateWarning.message }}
                              />
                            </div>
                          ) : null}
                          <div className="state-store-list">
                            {formattedLocationList[state]
                              .sort((a, b) => {
                                return a.storeName > b.storeName ? 1 : -1;
                              })
                              .map(store => (
                                <div key={store.objectID} className="store-list_name">
                                  <a href={store.url} key={store.objectID}>
                                    {store.storeName}
                                  </a>
                                </div>
                              ))}
                          </div>
                        </AccordionItemPanel>
                      </AccordionItem>
                    );
                  })}
              </Accordion>
            ) : null}
          </div>
        )}
      </div>
    );
  }
}

storeList.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  postcode: PropTypes.string.isRequired,
  currentLocation: PropTypes.PropTypes.shape().isRequired,
  getLocations: PropTypes.func.isRequired,
  setSearchData: PropTypes.func.isRequired,
};

export default storeList;
